// 微信分享 - 分享到朋友圈/朋友，别人点击可直接打开页面
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import request, { getImageSrc } from '../utils/request';

const isWeChat = () =>
  typeof window !== 'undefined' && /MicroMessenger/i.test(navigator.userAgent);

/** 朋友圈缩略图默认图：JSSDK 要求可访问的绝对 HTTPS 地址；勿用易缺失的 favicon.ico */
function getDefaultTimelineThumb() {
  let pub = process.env.PUBLIC_URL || '';
  if (pub === '/') pub = '';
  if (pub.endsWith('/')) pub = pub.slice(0, -1);
  const path = pub ? `${pub}/share-cover.jpg` : '/share-cover.jpg';
  return `${window.location.origin}${path}`;
}

function resolveShareImgUrl(imgUrl) {
  const s = typeof imgUrl === 'string' ? imgUrl.trim() : '';
  if (!s || s.startsWith('data:')) return getDefaultTimelineThumb();
  const resolved = getImageSrc(s);
  return resolved || getDefaultTimelineThumb();
}

/**
 * 配置当前页面的微信分享（朋友圈 + 好友）
 * @param {Object} options - 分享配置
 * @param {string} options.title - 分享标题
 * @param {string} [options.desc] - 分享描述（分享给好友时显示，朋友圈不显示 desc）
 * @param {string} [options.link] - 分享链接，默认当前页完整 URL
 * @param {string} [options.imgUrl] - 分享图标，建议 300x300
 */
export function useWxShare(options = {}) {
  const { title, desc = '', link, imgUrl } = options;
  const location = useLocation();

  useEffect(() => {
    if (!isWeChat() || !window.wx) return;
    if (!title) return;

    const currentUrl = window.location.href.split('#')[0];
    const shareLink = link || currentUrl;
    const shareImg = resolveShareImgUrl(imgUrl);

    const initShare = async () => {
      try {
        const res = await request({
          url: `/api/wx/jssdk?url=${encodeURIComponent(currentUrl)}`,
          method: 'GET'
        });
        const { appId, timestamp, nonceStr, signature } = res.data;
        if (!appId || !signature) return;

        window.wx.config({
          debug: false,
          appId,
          timestamp: Number(timestamp),
          nonceStr,
          signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        });

        window.wx.ready(() => {
          // 分享给朋友
          window.wx.updateAppMessageShareData({
            title,
            desc,
            link: shareLink,
            imgUrl: shareImg
          });
          // 分享到朋友圈
          window.wx.updateTimelineShareData({
            title,
            link: shareLink,
            imgUrl: shareImg
          });
        });
      } catch (err) {
        console.warn('微信分享配置失败:', err?.message);
      }
    };

    initShare();
  }, [title, desc, link, imgUrl, location.pathname]);
}
